import { render } from "./BrowseSearch.vue?vue&type=template&id=fe0eb4ec&scoped=true"
import script from "./BrowseSearch.vue?vue&type=script&lang=js"
export * from "./BrowseSearch.vue?vue&type=script&lang=js"

import "./BrowseSearch.vue?vue&type=style&index=0&id=fe0eb4ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0eb4ec"]])

export default __exports__